import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import actions from './action';
import payPanel from './modules/pay_panel';
import statistics from './modules/statistics';
import charge from './modules/charge';
import bless from './modules/bless';
import vip from './modules/vip';
import gift from './modules/gift';
import miniProgram from './modules/miniProgram';
import config from './modules/config';
import square from './modules/square';
import order from './modules/order'
import { GOLD_PRICE } from '@/libs/utils/consts'
import cookie from '@/libs/utils/cookie';

Vue.use(Vuex);
const state = {
  experiment: {},
  appId: '', // 从后端获取
  openid: '',
  unionid: '',
  vod_type: '',
  bind_status: '',
  user_img: null,
  user_name: '未登录',
  balance: 0,
  is_vip: false,
  vip_end_time: '', // 非会员或过期为空,用来显示vip到期时间
  vip_endtime: '', // 新用户为空 ,vip过期依然返回过期时间,用来判断新老会员
  is_expired_vip: false, // 是否为过期会员
  song_like_count: '',
  appmusic_count: '',
  my_uploadsong: 0,
  my_contest: 0,
  vip_packages: [],
  from_type: 'default',
  have_photo: 0,
  bless_path: '',
  photo_path: '',
  photo_path_new: '',
  photo_interact_path_new: '',
  photoPath: {}, // 用于区分版本打点用的
  have_mv: 0,
  have_bullet: 0,
  have_like: 0,
  have_emoji: 0,
  have_gift: 0,
  have_score: '',
  have_mic: '',
  have_video: 0,
  have_jinhai: 0,
  ksong: 1,
  show_barrage: false, // 弹幕显示与否
  order_num: 1,
  zf_num: 0,
  gm_num: 0,
  lw_num: 0,
  zp_num: 0,
  istopVip: 1, // 是否支持vip置顶不被插功能
  showPlaycontrol: false, // 遥控是否显示
  ktvid: '',
  ktv_level: 0,
  ktv_name: '',
  showNotVip: false, // 是否显示非vip点歌加速弹窗
  showNotVipTitle: '', // 非vip点歌加速弹窗的歌曲名
  notVipTimer: null,
  showHomeToast: false,
  keepAlive: [''],
  showPad: false,
  nationalShow: false,
  init_enter: true,
  homeBttomAdShow: false, // 防止和loading一起显示
  homeBottomAdShow: false, // 用于获取vip信息后再显示首页底部广告 test
  roomid: '',
  room_ip: '',
  rank_info: [],
  isActivityOver: true,
  sex: 0,
  is_plusvip: 0,
  is_old_user: 0,
  is_72hour: 1,
  ad_src: '',
  wxconfig: false,
  isMinProgram: false,
  orderedToast: [],
  room_stat: '',
  user_scan_fr: '',
  barchat_send_times: 0, // 酒吧模式下的免费礼物
  fansModalVipShow: false, // 吸粉赠送vip弹窗是否显示
  recommendPhotoShow: false, // 推荐图片弹窗是否显示
  likeSongs: [],
  isOrderSong: false,
  isGold: false,
  isGoldMaster: false,
  isSingleRights: false,
  SREndTime: '2020-01-01 00:00:00',
  goldMessage: {},
  orderedSongNum: cookie.getCookie('orderSongnum') || 0,
  myOrderedSongNum: cookie.getCookie('myOrderedSongNum') || 0,
  is_song_added_toast: 0,
  skeletonName: '',
  openGold: false,
  isGrayscale: false,
  gmSwitch: 0,
  isTestOldVip: true, // 老用户复购测试变量
  dragDisableArea: null,
  on_last_month_isvip: 0, // 是否可以升级年费会员
  is_song_like_new: true, // 我的常唱  是否是新用户
  ccTotal: 0, // 我的常唱 常唱数量 https://m2miovoqda.feishu.cn/docx/YuSod93xnocQ2ZxPcpCcdth9nOg
  ccTotalShow: 0, // 我的常唱 展示数量
  special_control: '21.2vw',
  litongInfo: {}, // 利通小程序信息
  searchDefaultText: [], // 搜索框默认文案
  isShowOrderList: false, // 显示实时购买滚动条
  intervalShowOrderList: true, // 间隔显示购买滚动条
  currentOrderIndex: 0,
  is_leishi_device: false,
  isRaisePrice: false, // 是否显示提价套餐
  isPayedRaisePrice: false, // 是否支付过提价的套餐
  presentVipPackages: [ // 月会员调整
    {
      'pkg_id': 77,
      'current_fee': 1980,
      'desc': '1日体验+赠送好友',
      'days': 1,
    },
    {
      'pkg_id': 75,
      'current_fee': 3980,
      'desc': '1个月+赠送好友',
      'days': 30,
    },
    {
      'pkg_id': 49,
      'current_fee': 4380,
      'desc': '3个月+赠送好友',
      'days': 365,
    },
  ],
  popPayPrice: { // 支付弹窗价格:一档的金额
    memberId: 2,
    pay_fee: 990, // 月会员调整
  },
  showOpenToast: true, // 是否展示开屏弹窗 拆分之前的isToastWhite
  showSongToast: true, // 是否展示点歌后弹窗
  isVipSongWhite: false, // 是否显示vip歌曲白名单
  isVipFirstToast: false, // 是否显示抢鲜唱弹窗
  activeTab: '', // 当前激活的tab
  is_leike_device: false, // 是否是雷客
  is_leike_device_new: false, // 是否是雷客 单独给我的页使用
  is_bar_device: false, // 是否是酒吧
  is_huisuo_device: false, // 是否是会所
  /** 房台类型：/c0/config/home 的 stb.tp，如 hs 表示会所盒子 */
  stb_tp: '',
  is_huisuo_disco: false, // 是否支持蹦迪会所
  Mac: '',
  orderSuccessVisible: false, // 点歌成功toast-优先唱
  orderSuccessConfig: {}, // 点歌成功toast-配置
  goldPrice: GOLD_PRICE.notVip, // 金主价格
  youxianSuffix: '', // 点歌成功toast-来源
  photoPag: 0,
  giftPag: 0,
  blessPag: 0,
  isDiscoStart: false,
  isSupportInteract: true, // 是否支持互动
  supportPAG: false, // 是否支持 PAG 特效
  hasFreeVipM: false, // 是否有资格领取体验VIP
  isFreeVipM: true, // 是否领取过体验VIP
  customerCountProcess: null, // 我的页：5元限时红包——倒计时进度
  // 重庆地区限制：https://m2miovoqda.feishu.cn/wiki/wikcnh9d86WZYwotHuSHSs6c2md
  isBlockInteractText: false, // 是否禁止文字上屏
  appHistory: 1, // 历史记录
  isAgreeShow: false, // 用户协议弹窗
  indexNavData: [], // 首页金刚区数据
  isLeikeLinux: false, // 是雷客设备下linux环境
  isLeikeExpire: false, // 雷客盒子是否过期
  leikeJumpUrl: '', // 雷客盒子跳转地址
  hideOrderedDelete: true, // 是否隐藏已点删除按钮
  vip_type_230906: 0, // 1：VIP用户，最近一笔是1日VIP订单，12小时内即将到期的 2：最近一笔是非1日VIP订单，20天内即将到期的
  SetTopDate: false, // 机顶盒是否在未过期 0-30天之内
  isShowScode: false, // 未绑房台引导弹窗
  // | 新用户-非VIP | role2 |
  // | 老用户-非VIP-从未付费 | role5 |
  // | 老用户-非VIP-会员过期 | role4 |
  // | 新用户-VIP | role1 |
  // | 老用户-VIP | role3 |
  role: 'role6', // 用户身份：https://m2miovoqda.feishu.cn/wiki/OleEwgg2eiqg27kWFhqc3kSnnve
  $theme: 'light', // 默认主题
  themeOrderIcon: {}, // 主题对应的点歌icon
  isShowGiftBox: false,
  showPhotoToast: false, // 是否展示照片弹窗
  photoToastEntrance: '', // 新增字段用于存储来源
  isShowPayToast: false, // 是否展示支付弹窗
  isShowVoiceSearch: false, // 是否展示语音点歌弹窗
  pendingPayment: null, // 待支付的套餐信息
  isControlBottom: false, // 控制遥控按钮位置
  is90ExpireDevice: false, // 是否是90后过期设备
  wallpaperData: [], // 壁纸数据
  is_lk_linux_vipsong: false, // https://m2miovoqda.feishu.cn/docx/UOWSd7U9wolSHJxzOBpcXjKxnie
  hasPhotoPrivilege: false, // 是否有照片权限
  is_refund_black: 0, // 是否在退款黑名单中
};
const Store = new Vuex.Store({
  state,
  actions,
  mutations,
  modules: {
    payPanel,
    statistics,
    charge,
    bless,
    vip,
    gift,
    miniProgram,
    config,
    square,
    order,
  },
});
export default Store;
